export const useIsEco = () => {
  const isEco = window.env.GENERIC_FRONTEND_REACTJS_STATUS_ECO;

  return { isEco }
}